<template>
  <v-card flat class="pa-4">
    <v-switch label="Allow Satuday scheduling" dense v-model="preferences.allowSaturday"/>
    <v-switch label="Allow Sunday scheduling" dense v-model="preferences.allowSunday"/>
    <v-switch label="Hide non-scheduled weekend days" dense v-model="preferences.hideWeekend"/>
    <v-select label="Week starts on" :items="['Sunday','Monday']" outlined dense v-model="preferences.weekStart" class="mt-4"/>
  </v-card>
</template>

<script>
export default {
  name: 'PlanningSchedulingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation PlanningSchedulingPreferences($input:SchedulePreferencesInput!) {
                                              scheduleSetPreferences(input:$input) {
                                                allowSaturday,allowSunday,hideWeekend,weekStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.scheduleSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query PlanningSchedulingPreferences {
                                          schedulePreferences {
                                            allowSaturday,allowSunday,hideWeekend,weekStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.schedulePreferences;
  }
}
</script>